export default {
  TITLE: "Rapport des rapports hebdomadaires",
  TOTAL_SALES: "Total ventes",
  TOTAL_PURCHASES: "Total achats",
  NET_PROFIT: "Profit net",
  TOTAL_WAGES: "Salaires totaux",
  TOTAL_RENT: "Loyer total",
  WEEKLY_AVERAGE_SALES: "Moy. ventes / semaine",
  AVG_WAGES_RATIO: "Ratio salaires moyen",
  AVG_RENT_RATIO: "Ratio loyer moyen",
  AVG_PURCHASES_RATIO: "Ratio achats moyen",
  AVG_NET_PROFIT_RATIO: "Ratio profit net moyen",
  AVG_PER_WEEK: "Moyenne / semaine",
  AVG_RATIO: "Ratio moyen",
  SALES: "Ventes",
  PURCHASES: "Achats",
  PURCHASES_CONSUMABLES: "Achats comestibles",
  PROFITS: "Profits",
  NUMBER_OF_REPORTS: "Nombre de rapports",
  EVOLUTION_OVER_TIME: "Évolution ventes / achats / profit",
  RATIOS_EVOLUTION_OVER_TIME: "Évolution des ratios",
  PERIOD: "Période",
  WAGES: "Salaires",
  RENT: "Loyer",
  WAGES_RATIO: "Ratio salaires",
  RENT_RATIO: "Ratio loyer",
  PURCHASES_RATIO: "Ratio achats",
  NET_PROFIT_RATIO: "Ratio profit",
};
